module.exports = __webpack_public_path__ + "img/step11.1ed90e9b.png";